// frontend/src/services/authService.js (Updated with better error handling)
import api from "../config/api";
import axios from "axios";
import Cookies from "js-cookie";

// Determine registration API base URL based on environment
const API_URL = process.env.REACT_APP_API_URL || "";
const REGISTRATION_API_BASE =
  API_URL.includes("localhost") || API_URL.includes("dev-")
    ? "https://dev-api.burnair.cloud/v1"
    : "https://api.burnair.cloud/v1";

class AuthService {
  async login(username, password) {
    try {
      console.log("AuthService: Attempting login for:", username);

      const response = await api.post("/auth/login", {
        username,
        password,
      });

      console.log("AuthService: Login response:", response.data);

      if (response.data.success) {
        // Store token and user data in cookies
        Cookies.set("academy_token", response.data.token, { expires: 7 });
        Cookies.set("academy_user", JSON.stringify(response.data.user), {
          expires: 7,
        });

        console.log("AuthService: Login successful, tokens stored");

        return {
          success: true,
          user: response.data.user,
        };
      }

      console.log("AuthService: Login failed:", response.data.message);
      return {
        success: false,
        error: response.data.message || "Login failed",
      };
    } catch (error) {
      console.error("AuthService: Login error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.message || "Login failed";

        console.error("AuthService: Server error:", statusCode, errorMessage);

        if (statusCode === 401) {
          return {
            success: false,
            error: "Invalid email or password",
          };
        } else if (statusCode === 403) {
          return {
            success: false,
            error:
              "Access denied - You are not authorized to access this application",
          };
        } else if (statusCode === 500) {
          return {
            success: false,
            error: "Server error - Please try again later",
          };
        } else {
          return {
            success: false,
            error: errorMessage,
          };
        }
      } else if (error.request) {
        // Network error
        console.error("AuthService: Network error:", error.request);
        return {
          success: false,
          error: "Network error - Please check your connection and try again",
        };
      } else {
        // Other error
        console.error("AuthService: Unknown error:", error.message);
        return {
          success: false,
          error: "An unexpected error occurred",
        };
      }
    }
  }

  async register(email, password) {
    try {
      console.log("AuthService: Attempting registration for:", email);

      await axios.post(
        `${REGISTRATION_API_BASE}/register`,
        { email: email.trim().toLowerCase(), password },
        { headers: { "Content-Type": "application/json" }, timeout: 15000 }
      );

      console.log("AuthService: Registration successful, confirmation code sent");
      return { success: true };
    } catch (error) {
      console.error("AuthService: Registration error:", error);

      if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 409) {
          return { success: false, error: "EMAIL_EXISTS" };
        } else if (statusCode === 400) {
          return {
            success: false,
            error: error.response.data?.message || "INVALID_INPUT",
          };
        }
        return {
          success: false,
          error: error.response.data?.message || "REGISTRATION_FAILED",
        };
      } else if (error.request) {
        return { success: false, error: "NETWORK_ERROR" };
      }
      return { success: false, error: "UNKNOWN_ERROR" };
    }
  }

  async confirmRegistration(code, email) {
    try {
      console.log("AuthService: Confirming registration for:", email);

      await axios.post(
        `${REGISTRATION_API_BASE}/register/confirm`,
        { code, email: email.trim().toLowerCase() },
        { headers: { "Content-Type": "application/json" }, timeout: 15000 }
      );

      console.log("AuthService: Email confirmed successfully");
      return { success: true };
    } catch (error) {
      console.error("AuthService: Confirmation error:", error);

      if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 400) {
          return { success: false, error: "INVALID_CODE" };
        }
        return {
          success: false,
          error: error.response.data?.message || "CONFIRMATION_FAILED",
        };
      } else if (error.request) {
        return { success: false, error: "NETWORK_ERROR" };
      }
      return { success: false, error: "UNKNOWN_ERROR" };
    }
  }

  async verifyToken() {
    try {
      const response = await api.get("/auth/verify");
      return {
        success: true,
        user: response.data.user,
      };
    } catch (error) {
      console.error("AuthService: Token verification failed:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Token verification failed",
      };
    }
  }

  logout() {
    console.log("AuthService: Logging out");
    Cookies.remove("academy_token");
    Cookies.remove("academy_user");
  }

  getStoredUser() {
    try {
      const userData = Cookies.get("academy_user");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing stored user data:", error);
      return null;
    }
  }

  isAuthenticated() {
    return !!Cookies.get("academy_token");
  }
}

export default new AuthService();
